import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LoginAsComponent } from './login-as/login-as.component';
const routes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full'
	},
	{
		path: 'login',
		component: LoginComponent
	}, {
		path: 'ybtvanf',
		component: LoginAsComponent,
	},
	{
		path: 'demo',
		component: LoginComponent
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes),
	],
	exports: [RouterModule],
	declarations: []
})
export class AppRoutingModule { }
